import { KneelResponseOptionsType } from './types';

export const KNEEL_RESPONSE_OPTIONS: KneelResponseOptionsType = [
  {
    id: 'already_kneeling',
    title: "I'd already be on my knees",
  },
  {
    id: 'look_in_eyes',
    title: 'Only if you looked me in the eyes',
  },
  {
    id: 'hesitate_but_do',
    title: "I'd hesitate... but I'd do it",
  },
  {
    id: 'never',
    title: 'Never',
  },
];
